import { Component, OnInit, ElementRef, ViewChild, EventEmitter, AfterViewInit,Input,Output } from '@angular/core';
import { BdpService } from '../../../../areas/bdp/bdp.service';
import { NgModel } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { NgForm } from '@angular/forms';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwTabService } from 'src/app/librarys/serves/public/sw-tab.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
declare var $: any;
@Component({
  selector: 'sw-dynamic-form-view-tab',
  templateUrl: './sw-dynamic-form-view-tab.component.html',
  styleUrls: ['./sw-dynamic-form-view-tab.component.css']
})
export class SwDynamicFormViewTabComponent implements OnInit, AfterViewInit {
   isShow = false;
   formInformation: FormInformtion = {
     formName: "",
     formCode: "",
     description: "",
     areas: [{ areaId: '1', colId: '0', px: '0' ,title:''}],
     status: 1,
     params: []
   };
   elements;
   information = {
     _paramName: "",
     result: ""
   }
   formValue = {}; // 用于封装表单数据
   formId;
   keyParam: ElementInformtion; //主键元素
   headerLoGo = "查看";
   
   fileIsReadOnly: boolean = true;    //附件是否只读
   isReadOnly: boolean = true;    //图片是否只读
   fileBusinessId: string = ''    //业务id  
  
   fileCode2 = {}; //为上传图片组件functionId 策略
   fileCode1 = {}; // 为上传附件组件的functionId 策略
   dataId: any = "";//新增时  策略id参数
   dictionaryDatas: any = [];//获取所有字典数据

   prefix: string = environment.seekerWebAPI;

   environmentWebAPI = '';
   environmentCkeditor = environment.staticFileUrl; //富文本图片上传的服务地址
   closeUrl = ''//页面关闭后跳转的页面
   WebAPIType = '' //业务类型  用于关闭当前页面的路径判断
   isUseOrg:boolean = false; //判断表单属性是否有 isOrg=true的情况,如果有则isUseOrg=true,反之isUseOrg=false（execute的接口用到;新增、修改、删除和查询表单时用到）
   @Input() param:any;
   @Output() callback = new EventEmitter(); //抛出事件
   @ViewChild('modal') modal: SwModalframeComponent;
   constructor(
     public element: ElementRef,
     private service: BdpService,
     private http: SwHttpClientService,
     private activedRouter: ActivatedRoute,
     private router: Router,
     private tagServe: SwTabService,
     private systemId:SystemIdService,
     private jwt: SwJwtService,
   ) { 
    this.activedRouter.queryParams.subscribe((param) => {
      let data = JSON.parse(param['data'])
     // let Ckeditor = data['environment'].split(":")[0]
      //this.environmentCkeditor = environment[Ckeditor];
      this.WebAPIType = data['environment'];
      let webApi = data['environment']+'WebAPI';
      this.environmentWebAPI = environment[webApi];
      this.closeUrl = data['closeUrl']
      let formId = data['formId'];
      let checkedId = data['checkedId'];
      if(param.Title){
       this.locationFormInfo(formId, checkedId)
      }
   
   })
   }
 
 
   ngOnInit() {
    //  let formInformation = this.param['formInformation'];
    //  let checkedData = this.param['checkedData'];
    //  this.initFormInformation(formInformation, checkedData)
   }
 
   ngAfterViewInit() {
   }
   //根据表单id获取表单元素信息;根据已选择的表格行id获取该行的所有信息
   locationFormInfo(formId, checkedId) {
    //根据表单id获取表单元素信息
    this.queryParamsPageList(formId).subscribe(response => {
      let params = [];
      let tableId;
      let primaryKey;
      params = (<any>response).data.records;
      this.formInformation['params'] = params;
      this.formInformation['formId'] = formId;
      if (params.length) {
        let keyparam = params.filter(item => item.type == 'key');
        keyparam.forEach(val=>{
           //获取主数据表 对应的绑定主键列表
           if(val.controlType == 'text'){
             tableId = val['tableId']
             primaryKey = val['paramCode']
           }
        })
         //根据主表的tabeId, 获取该主数据表所有的外键  paramCode 和 coulmId  再根据coulmId 获取对应现有表单元素elements的paramCode
         this.getTableFk(tableId);
      }
      //如果checkedId 存在 为修改页面 需要获取选中的行数据
      if(checkedId){
        setTimeout(()=>{
            //获取选中行的数据
            this.getPageList(tableId,formId,primaryKey,checkedId,this.formInformation)
        },200)
       
      }
    })
  }
     //根据主表的tabeId, 获取该主数据表所有的外键  paramCode 和 coulmId  再根据coulmId 获取对应现有表单元素elements的paramCode
     getTableFk(keyTableId){
      let param = { ids:[ keyTableId],systemId:this.systemId.getSystemId()};
      //根据主表tableId查询对应的 主键字段列表
      this.service.getFormDesignService().queryColumnsByTableId(param).subscribe(res => {
        if(res['code']==200){
          let columns = res['data'];
           //判断主表是否为组织权限
           if(columns.length > 0){
            //判断该表单的是否包含属性 isOrg = true的元素，若有 this.isUseOrg = true 否则 this.isUseOrg=false
            let orgs = columns.filter(item=>item.isOrg == true)
            if(orgs.length == 0){
              this.isUseOrg=false
            }else {
              this.isUseOrg = true
            }
          }
        }
        
  
      });
    }
  /**
   * 查询列表
   * @param {any} formId 
   * @param {any} pager 
   * @param {any} param //查询条件
   * @memberof TestListComponent
   */
  getPageList(tableId,formId,primaryKey,checkedId,formInformation) {
    const url = this.environmentWebAPI+'dynamic/'+ 'execute?action=1&formId=' + formId + `&isUseAlias=true&pageNum=${1}&pageSize=${10}&isUseOrg=${this.isUseOrg}`;
    // 过滤已删除的数据
    let param = {}
    let checkedData;
    param[tableId+'.'+ primaryKey] = ['like',checkedId, '']
    // this.add.formatData();
    // 查询业务数据
    this.http.Post(url, param).subscribe(res => {
      let val = (<any>res).data.data.list;
      val.forEach(ele=>{
        if(ele[primaryKey] == checkedId){
          checkedData = ele;
          //初始化表单元素
          this.initFormInformation(formInformation, checkedData)
        }
      })

    })
  }

  //点击取消
  clickCancel(){
    let projectName= this.closeUrl.split('/')[2]
    this.tagServe.closeUrl("/"+this.WebAPIType+"/DynamicFormView/"+projectName, true);
    this.tagServe.gotoUrl(this.closeUrl)
  }

   //上传图片  上传附件 文件策略暂时获取假数据 （后台目前没有此字段）
   staticFileCodeData() {
     this.fileCode2 = {};
     //以下为上传图片 上传文件 文件标识的假数据
     this.formInformation.params.forEach(val => {
       if (val.controlType == 'image') {
         //真数据 暂时注释
         if (val['description']) {
           this.fileCode2[val.paramCode+val.imageSort] = val['description'];
         }
       }
       if (val.controlType == 'files') {
         // val['fileCode'] = 'ddd';  //当为动态获取时 删除
         if (val['description']) {
          this.fileCode1[val.paramCode+val.filesSort] = val['description'];
        }
       }
     })
 
   }
 
   // 接收表单信息,初始化表单内容
   initFormInformation(formInformation, checkedData) {
     this.formValue = {};
     this.fileBusinessId = '';
     //this.f.reset();
     this.formId = formInformation.formId;
     this.formInformation = formInformation;
     // 过滤出表单元素
     this.elements = this.formInformation.params.filter(item => item.isHidden == 'false' || item.isHidden == false);
     // 过滤出主键元素
     this.keyParam = this.formInformation.params.filter(item => item.type == 'key')[0];
      //获取字典数据
      //从浏览器缓存获取字典数据
     let dic = JSON.parse(this.jwt.getToken('dictionary'))
     this.dictionaryDatas = [...dic]
     //用于存储接受的数据
     this.initRequest(this.elements,checkedData);
     //用于静态设置上传图片序号
     this.sortElementsImage();
     //用于静态设置上传附件事件 变量
     this.sortElementsFiles()
     //上传图片 附件的策略赋值
     this.staticFileCodeData();
     //初始化区域
     this.initAreas();
      // 查看
      if (checkedData) {
        for (const key in checkedData) {
          if (checkedData[key] === true || checkedData[key] === false) {
            checkedData[key] = checkedData[key] + ''
          }
        };
        this.formValue = {};
        this.formValue = { ...checkedData }
        //富文本转换绝对路径 用于显示在页面上
        this.toAbsolutePath();
        //获取主键的字段
        let paramCode = this.keyParam['paramCode'];
        this.fileBusinessId = checkedData[paramCode];
      } 
   }
   //对元素含有图片元素进行排序编号 以便对策略id和对应事件 变量进行分类
   sortElementsImage() {
     let i = 0;
     this.elements.forEach(element => {
       if (element.controlType == 'image') {
         i++;
         element.imageSort = i;
       }
     });
   }
     //对元素含有文件元素进行排序编号 以便对策略id和对应事件 变量进行分类
  sortElementsFiles() {
    let i = 0;
    this.elements.forEach(element => {
      if (element.controlType == 'files') {
        i++;
        element.filesSort = i;
      }
    });
  }
   //初始区域
   initAreas() {
     //找出区域 列 px 的信息
     let arr = []
     this.formInformation.params.forEach(val => {
       val.groupName1 = JSON.parse(val.groupName)
       let num = 0;
       arr.forEach(ele => {
         if (val.groupName1.areaId == ele.areaId) {
           num = 1;
         }
       })
       if (num == 0) {
         arr.push(val.groupName1)
       }
     })
     this.formInformation.areas = arr;
   }

   //用于存储接受的数据
   initRequest(elements,checkedData) {
     //发送请求的参数
     elements.forEach((value) => {
       let arr = [];
       if (value.requestUrl) {
         //决定数据来源
         let param1 = value.requestUrl.split("/")[1];
         //决定那条数据
         let param2 = value.requestUrl.split("/")[2];
         let type = value['controlType'];
         //param1：1 数据来源为数据字典， param1：2 数据来源为钉钉用户
          if(param1 == 1) {
             //发送请求
                //对数据来源的数据进行过滤
                let requestUrl = this.dictionaryDatas.filter(val => {
                  return val.parentId == param2;
                });
                requestUrl = requestUrl.map((val, index) => {
                  //将id修改为val.id
                  return {
                    // id: val.id + "",
                    id: val.dictionaryValue,
                    text: val.dictionaryName,
                    status: false
                  }
                });

            //根据单选框，多选框，下拉框，下拉复选框id获取text值
            if(checkedData){
              let checkedDataValue = checkedData[value.paramCode]+''; //设置为字符串 将值为 true 或false 转化为字符串 便于后面分割为数组
              if(checkedDataValue){
              this.information[value.paramCode] = [];
                let arr11 = checkedDataValue.split(','); //将保存的id（其id为单选或多选时 选中的id）字符串转为数组
                arr11.forEach(ele => {
                  //判断是否为is_xx true 或者false
                  if (ele == 'true') {
                    ele = '1'
                  } else if (ele == 'false') {
                    ele = '0'
                  }
                  requestUrl.forEach(val => {
                    if (ele == val.id) {
                      val.status = true;
                    }
                  })
                });
                //修改时  对存储信息变量 information 赋值 
                requestUrl.forEach(val => {
                  if (val.status) {
                    this.information[value.paramCode].push(val.text)
                  }

                })
              }
            }
            //确定需要的数据
            value.requestData = requestUrl;
            value.requestStrData = this.information[value.paramCode].join(" ")
           
         }else {
           if(param1 == 2) {
             //数据来源为钉钉用户
           }else if(param1 == 0 && (type =='radio' || type =='checkbox' || type =='select' || type =='selectCheckbox')){
            //数据来源为绑定的表单
            let formId = param2
            //根据formId获取关联的表单元素
            this.queryParamsPageList(formId).subscribe(response => {
              let pairParam2='';//关联表单对应的表单字段元素 对应的字典 id
              let params = [];
              params = (<any>response).data.records;
              pairParam2 = params.filter(item=>item['paramCode'] == value['paramCode'])[0]['requestUrl'].split("/")[2];
             
              //对数据来源的数据进行过滤
              let requestUrl = this.dictionaryDatas.filter(val => {
                return val.parentId == pairParam2;
              });
              requestUrl = requestUrl.map((val, index) => {
                //将id修改为val.id
                return {
                  // id: val.id + "",
                  id: val.dictionaryValue,
                  text: val.dictionaryName,
                  status: false
                }
              });
              //根据单选框，多选框，下拉框，下拉复选框id获取text值
              if(checkedData){
                let checkedDataValue = checkedData[value.paramCode]+''; //设置为字符串 将值为 true 或false 转化为字符串 便于后面分割为数组
                if(checkedDataValue){
                this.information[value.paramCode] = [];
                  let arr11 = checkedDataValue.split(','); //将保存的id（其id为单选或多选时 选中的id）字符串转为数组
                  arr11.forEach(ele => {
                    //判断是否为is_xx true 或者false
                    if (ele == 'true') {
                      ele = '1'
                    } else if (ele == 'false') {
                      ele = '0'
                    }
                    requestUrl.forEach(val => {
                      if (ele == val.id) {
                        val.status = true;
                      }
                    })
                  });
                  //修改时  对存储信息变量 information 赋值 
                  requestUrl.forEach(val => {
                    if (val.status) {
                      this.information[value.paramCode].push(val.text)
                    }

                  })
                }
              }
              //确定需要的数据
              value.requestData = requestUrl;
              value.requestStrData = this.information[value.paramCode].join(" ")
            })
           }else if(param1 == 3 && param2 == 1){
            //关联组织数据处理
            //查询组织结构
            let requestUrl;
            let param = { "param": { pageSize: 0 ,isAdminQuery:true}, "entity": {systemId:this.systemId.getSystemId()} }
            this.service.getDepartmentService().queryOrganizePageList(param).subscribe(
              data => {
                if (data["code"] == 200) {
                  let orgarray = [];
                  data["data"]["records"].forEach(e => {
                    if(e.status){
                      e.checked = false;
                      orgarray.push(e);  //筛选掉已禁用数据
                    }
                  });
                  requestUrl = orgarray;
                  let requestStrData = []; //该数组用于表单查看单选 多选 下拉框 多选下拉框数据text数组
                  if(checkedData){
                   let checkedDataValue = checkedData[value.paramCode]+''; //设置为字符串 将值为 true 或false 转化为字符串 便于后面分割为数组
                   if(checkedDataValue){
                   this.information[value.paramCode] = [];
                     let arr11 = checkedDataValue.split(','); //将保存的id（其id为单选或多选时 选中的id）字符串转为数组
                     arr11.forEach(ele => {
                       requestUrl.forEach(val => {
                         if (ele == val.id) {
                           val.checked = true; //因为已有status属性 所以用checked判断是否已选字段
                         }
                       })
                     });
                     //修改时  对存储信息变量 information 赋值 
                     requestUrl.forEach(val => {
                       if (val.checked) {
                         this.information[value.paramCode].push(val.id)
                         requestStrData.push(val.text);
                       }
                     })
                   }
                 }
                  //确定需要的数据
                 value.requestData = requestUrl;
                 value.requestStrData = requestStrData.join(" ")
                }
              }
            )

          }else if(param1 == 3 && param2 == 2){
           //关联系统用户
           let requestUrl;
           //查询系统所有用户
           let param1 = {systemId: this.systemId.getSystemId()}
           this.service.getUserService().queryList(param1).subscribe( //查询用户
             data => {
               if (data["code"] == 200) {
                 let arr1 = []
                 let result = data["data"]
                 result.forEach(user => {
                   if(user.status){
                     // 查询所有用户，默认没有用户被选中
                     arr1.push({id:user.userId,text:user.displayName,pid:'999',checked:false})
                   }
                 });
                 //所有的用户
                 requestUrl = arr1
                 let requestStrData = []; //该数组用于表单查看单选 多选 下拉框 多选下拉框数据text数组
                 if(checkedData){
                  let checkedDataValue = checkedData[value.paramCode]+''; //设置为字符串 将值为 true 或false 转化为字符串 便于后面分割为数组
                  if(checkedDataValue){
                  this.information[value.paramCode] = [];
                    let arr11 = checkedDataValue.split(','); //将保存的id（其id为单选或多选时 选中的id）字符串转为数组
                    arr11.forEach(ele => {
                      requestUrl.forEach(val => {
                        if (ele == val.id) {
                          val.checked = true; //因为已有status属性 所以用checked判断是否已选字段
                        }
                      })
                    });
                    //修改时  对存储信息变量 information 赋值 
                    requestUrl.forEach(val => {
                      if (val.checked) {
                        this.information[value.paramCode].push(val.id)
                        requestStrData.push(val.text);
                      }
                    })
                  }
                }
                 //确定需要的数据
                 value.requestData = requestUrl;
                 value.requestStrData = requestStrData.join(" ")
               }
             }
           )
          }
         }
       }
     })
   }

      /**
 * 根据formId查询参数
 * @param param
 * @returns {Observable<any>}
 */
  queryParamsPageList(formId) {
    let param = {
      entity: { formId: formId },
      param: { pageSize: 0, orderBy: "seq" }
    }
    const url = this.prefix + 'form/queryParamsPageList';
    return this.http.Post(url, { ...param });
  }
    //富文本转换相对路径 用于存储到数据库
  toRelativePath() {

    //处理富文本类型 富文本图片视频地址转换为相对路径存储
    //转义双引号
    let aquotes: string = '"'
    let newaQuotes: string = '\"'
    //替换分号
    let branch: string = ';'
    let newBranch: string = 'bra&nch'
 
     let path: string = this.environmentCkeditor;
     let newPath: string = "ht&tp";
     this.formInformation.params.forEach(val => {
       if (val.controlType == 'ckeditor') {
         if(this.formValue[val.paramCode]){
          this.formValue[val.paramCode] = this.formValue[val.paramCode].replace(new RegExp(path, "gm"), newPath);
          let newData = this.formValue[val.paramCode].replace(new RegExp(aquotes, "gm"), newaQuotes);
          this.formValue[val.paramCode] = newData.replace(new RegExp(branch, "gm"), newBranch);
         }
       }
     })
   }
   //富文本转换绝对路径 用于显示在页面上
   toAbsolutePath() {
    //转义双引号
    let aquotes: string = '"'
    let newaQuotes: string = '\"'
      //替换分号
    let branch: string = ';'
    let newBranch: string = 'bra&nch'
 
     let path: string = this.environmentCkeditor;
     let newPath: string = "ht&tp";
     this.formInformation.params.forEach(val => {
       if (val.controlType == 'ckeditor') {
         let newData = ''
         newData = this.formValue[val.paramCode]
         //类似以下标签保存成功从新获取 取不到
         //<img alt="smiley" src="http://localhost:4200/assets/Scripts/ckeditor_4.11.1_full/ckeditor/plugins/smiley/images/regular_smile.png" style="height:22px; width:22px" title="smiley" /> 
         if(newData) {
          newData =  newData.replace(new RegExp(newPath, "gm"), path);
          newData.replace(new RegExp(newaQuotes, "gm"), aquotes);
          this.formValue[val.paramCode] = newData.replace(new RegExp(newBranch, "gm"), branch);
         }
       }
     })
   }

}

//接口
export interface FormInformtion {
  formName: string,
  formCode: string,
  areas: Array<any>,
  description: string,
  status: number,
  params: Array<any>
}
export interface ElementInformtion {
  id: number,
  tableId: string,
  columnId: string,
  controlType: string,
  type: string;
  paramName: string,
  paramCode: string,
  formula: string,
  validatePrompt: string,
  timeFormat: string,
  pictureFormat: string,
  fileFormat: string,
  defaultValue: string,
  isHidden: string,
  isNotNull: string,
  isQueryParam: string,
  isListParam: string,
  isFormParam: string,
  groupName: string,
  description: string,
  isDataRequest: number,
  className: string,
  requestUrl: string,
  rows: number,
  height: number,
  seq: number,
  length: number,
  minLength: number,
  listWidth: number
}

